__webpack_require__.p = "/reports-skeleton-ui-improvement/referrals-hub/";